export enum LoadingType {
  Spinner,
  SkeletonTable,
}
